import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const CLASS_NAME = 'btn btn-myed btn-default btn-default-myed btn-sm-myed mr-4'

const LABEL = (
  <React.Fragment>
    <div className="fa-regular fa-arrow-circle-left fa-fw mr-2" /> Go Back
  </React.Fragment>
)

/**
 * The dashboard's "Go Back" control.
 *
 * Goes UP one level in the page hierarchy -- `to` is the page's parent. It is
 * not the browser's back button and does not follow history, so it lands in
 * the same place no matter how the user reached the page.
 *
 * Keep it an anchor carrying `to` as its href: that is what lets
 * right/middle/modified-click open the parent in a new tab. Converting it to
 * a <button>, or adding an onClick that always calls preventDefault, breaks
 * that silently.
 */
export const GoBackLink = ({ to, external = false }) =>
  // `external` targets sit outside the dashboard's routes: a <Link> there
  // matches nothing and renders an empty page.
  external ? (
    <a href={to} className={CLASS_NAME}>
      {LABEL}
    </a>
  ) : (
    <Link to={to} className={CLASS_NAME}>
      {LABEL}
    </Link>
  )

GoBackLink.propTypes = {
  to: PropTypes.string.isRequired,
  external: PropTypes.bool,
}
